<template>
  <div class="c-policy">
    <!-- filter -->
    <policy-filter placeholder="请输入策略模板名称或ID" @on-change="filterData" @on-search="searchFilterData" />

    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <policy-table
          ref="policyTable"
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :columns="tableCols"
          @on-del="deleteRowPolicy"
          @on-refresh="getData"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/policy_column'
import { isArray, timeout } from '@/common/js/utils'
import { setLocal } from '@/common/js/api'
import PolicyFilter from './components/policy-filter'
import PolicyTable from './components/policy-table'
import { listPolicy, delPolicy } from '@/api/manage.model'

export default {
  name: 'policy',
  mixins: [mixin],
  components: { PolicyFilter, PolicyTable },
  computed: {
    tableCols() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      listPolicy(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    deleteRowPolicy({ id }) {
      this.loading = true
      delPolicy({ id }).then((data) => {
        this.loading = false
        if (data) {
          this.$Message.success('策略模板删除成功！')
          timeout(600).then(() => {
            this.getData()
          })
        }
      })
    },
    setLocalPage(size) {
      setLocal('POLICY_PAGESIZE', size)
    }
  },
  data() {
    return {
      tableHeight: 330,
      tableList: [],
      columns: columns
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table-page {
  padding: 5px;
  text-align: right;
}
</style>
